import api from 'ApiConfig';

const jobServices = {
  getAllJobs: async (courseId) => {
    return api.post('/admin/get-job-post', { courseId });
  },
  getFeedbackForJob: async (jobAssignmentId) => {
    return api.post(
      '/admin/get-assigned-job-feedback-all-students',
      jobAssignmentId
    );
  },
  pauseStudentPlacement: async (pauseDetails) => {
    return api.post('/admin/pause-placement', { pauseDetails });
  },
  getAllStudentsPauseStatus: async (studentIds) => {
    return api.post('/admin/get-all-placment-paused-status', { studentIds });
  },
  unpausePlacement: async (studentId, unpauseReason) => {
    return api.post('/admin/unpaused-placement', { studentId, unpauseReason });
  },
  requestUnpausePlacement: async (studentId, unpauseReason) => {
    console.log(studentId, unpauseReason, 'studentId , unpauseReason');
    return api.post('/admin/request-unpaused-placement', {
      studentId,
      unpauseReason,
    });
  },
};

export default jobServices;
